export const orderStatuses = [
  { value: 'PENDING', name: 'order_status.PENDING' },
  { value: 'ORDERED', name: 'order_status.ORDERED' },
  { value: 'ARRIVED', name: 'order_status.ARRIVED' },
  { value: 'DELIVERED', name: 'order_status.DELIVERED' },
];
